import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { ErrorCodeGeneralInjection } from "features/errorCodeGeneralFeature/di/ErrorCodeGeneralInjection";
import { injectable } from "tsyringe";
import { DetailErrorCodeGeneralEntity } from "../entities/DetailErrorCodeGeneralEntity";
import { ErrorCodeGeneralRequestEntity } from "../entities/ErrorCodeGeneralRequestEntity";
import { ErrorCodeGeneralResponseEntity } from "../entities/ErrorCodeGeneralResponseEntity";
import { IErrorCodeGeneralRepository } from "../repositories/IErrorCodeGeneralRepository";

@injectable()
export class ErrorCodeGeneralUseCase {
  private errorCodeGeneralRepo: IErrorCodeGeneralRepository;

  constructor() {
    this.errorCodeGeneralRepo = ErrorCodeGeneralInjection.getRepo();
  }

  async fetchGeneral(
    params: ErrorCodeGeneralRequestEntity,
  ): Promise<ListBaseApiResponseModel<ErrorCodeGeneralResponseEntity>> {
    delete params?.timeType;
    delete params?.classType;
    return await this.errorCodeGeneralRepo.fetchGeneral(params);
  }

  async fetchDetail(
    params: ErrorCodeGeneralRequestEntity,
  ): Promise<ListBaseApiResponseModel<DetailErrorCodeGeneralEntity>> {
    return await this.errorCodeGeneralRepo.fetchDetail(params);
  }

  async fetchReport(
    params: ErrorCodeGeneralRequestEntity,
  ): Promise<BaseApiResponseModel<Blob>> {
    return await this.errorCodeGeneralRepo.fetchReport(params);
  }
}
